import React from "react"
import PropTypes from "prop-types"

import AlertModal  from '../app_components/AlertModal'
import StandardModal from '../app_components/StandardModal'
import StandardButton from '../app_components/StandardButton'
import dateTimeFormat from '../utils/dateTimeFormat'
import ChangeLexForm from './ChangeLexForm'
//type = 'change' 'respond'

class MeetingResponse extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      approveLex: false,
      cancelLex: false,
      changeLex: false,
      changeLexDetails: false
    }

    this.approveLex = this.approveLex.bind(this)
    this.cancelLex = this.cancelLex.bind(this)
    this.changeLex = this.changeLex.bind(this)
    this.changeForm = this.changeForm.bind(this)
    this.changeLexDetails = this.changeLexDetails.bind(this)
  }

  componentWillUnmount() {
    this.setState({
      approveLex: false,
      cancelLex: false,
      changeLex: false
    })
  }

  approveLex() {
    this.setState({
      approveLex: true,
    })

    $.ajax({
      url: `../acceptMeeting`,
      dataType: 'JSON',
      type: 'POST',
      header: {
        'Content-Type': 'application/json'
      },
      data: {
        meeting_id: this.props.meeting.id
      },
      success: (data) => {
        this.props.getAllMeetings()
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    })

  }

  cancelLex() {
    this.setState({
      cancelLex: true
    })
    $.ajax({
      url: `../cancelMeeting`,
      dataType: 'JSON',
      type: 'POST',
      header: {
        'Content-Type': 'application/json'
      },
      data: {
        meeting_id: this.props.meeting.id
      },
      success: (data) => {
        //this.props.getAllMeetings()
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    })
  }

  changeLex() {
    this.setState({
      approveLex: false,
      cancelLex: false,
      changeLex: true,
      changeLexDetails: false
    })
  }

  changeLexDetails() {
    this.setState({
      approveLex: false,
      cancelLex: false,
      changeLex: false,
      changeLexDetails: true
    })
  }


  changeForm() {
    return(
      <StandardModal onClose={this.props.onClose} modalClass="meetingLexModal">
        <h3 className="meetingLexModal__title">I want to make changes to this Lex</h3>
        <div className="meetingLexModal__actions">
          <StandardButton
            text="Change details"
            primary={true}
            fullWidth
            icon="edit"
            onClick={() => this.changeLexDetails()}
          />
          <StandardButton
            alert={true}
            text="Cancel this Lex"
            fullWidth
            icon="times"
            onClick={() => this.cancelLex()}
          />
        </div>
      </StandardModal>
    )
  }



  render() {
    if(this.state.approveLex === true) {
      return(
        <AlertModal
          onClose={this.props.onClose}
          bannerText={"Success!"}
          headerText={`All set to Lex, ${dateTimeFormat(this.props.meeting.meeting_time)}!`}
          subHeaderText={"Next up: plan your Lex"}
          mainText={"Planning activities ensures your Lex is a success. Lexody provides games and activities to play. Pro tip: download the app for a better experience!"}
          buttonText={"Find activities for Lex"}
          onClick={() => window.location.replace(`/meetings/${this.props.meeting.id}`)}
        />

      )
    }
    if(this.state.cancelLex === true) {
      return(
        <AlertModal
          alert={true}
          onClose={this.props.onClose}
          bannerText={"Lex Cancelled"}
          headerText={"You have cancelled this Lex"}
          mainText={"It's okay. Try scheduling another Lex this week. Practice makes perfect!"}
          buttonText={"Close"}
          onClick={() => this.props.onClose()}
        />

      )
    }
    if(this.state.changeLex === true) {
      return (<div>{this.changeForm()}</div>)
    }
    if(this.state.changeLexDetails === true) {
      return (
        <ChangeLexForm
          meetingId={this.props.meeting.id}
          onClose={() => this.props.onClose()}
         />)
    }
    if (this.props.type === 'respond') {
      return(
        <StandardModal onClose={this.props.onClose} modalClass="meetingLexModal">
          <h3 className="meetingLexModal__title">Can you attend the Lex?</h3>
          <div className="meetingLexModal__actions">
            <StandardButton
              text={"Yes, I'll be there!"}
              primary={true}
              fullWidth
              icon="check-circle"
              onClick={() => this.approveLex()}
            />
            <StandardButton
              text={"Yes, but at a different time or location"}
              primary={false}
              fullWidth
              icon="edit"
              onClick={() => this.setState({changeLex: true})}
            />
            <StandardButton
              text={"No, I can not attend"}
              alert={true}
              fullWidth
              icon="times"
              onClick={() => this.cancelLex()}
            />
          </div>
        </StandardModal>
      )
    }
    if (this.props.type === 'change') {
      return (<div>{this.changeForm()}</div>)
    }

  }

}

export default MeetingResponse;
